import { Col, Image, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  TRANSLATION_NAMESPACES,
  TRANSLATION_LANGUAGE_LIST
} from 'util/translation/constant';
import { BaseSelect } from 'components/UI/BaseSelect';
import { EMExample, logo } from 'assets/images';
import { PrimaryButton } from 'components/UI/PrimaryButton';

const EM_URL = process.env.REACT_APP_EM_URL;
export const EMRedirectPage = () => {
  const { t, i18n } = useTranslation(TRANSLATION_NAMESPACES.AUTHENTICATION);

  const onChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const emModalDescription = t('emModalDescription');
  const emModalDescriptionParsed = emModalDescription
    .split('<br/>')
    .map((item) => {
      return <p key={item}>{item}</p>;
    });

  return (
    <div className="em-redirect-page">
      <BaseSelect
        className="custom-select language-selection"
        onChange={onChangeLanguage}
        defaultValue={i18n.language}
        listItemHeight={32}>
        {TRANSLATION_LANGUAGE_LIST.map((option) => (
          <BaseSelect.Option key={option.value} value={option.value}>
            <div>
              <img
                src={`/assets/images/icons/country/${option.icon}.svg`}
                alt={option.code}
                width="16"
                className="language-selection-country-icon"
              />
              &nbsp;&nbsp;
              {option.code}
            </div>
          </BaseSelect.Option>
        ))}
      </BaseSelect>
      <div className="em-redirect-header">
        <Image preview={false} src={logo} />
      </div>
      <hr />

      <Row className="em-redirect-page-body">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Image preview={false} src={EMExample} />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <h1>{t('emModalTitle')}</h1>
          {emModalDescriptionParsed.map((item) => item)}
          <PrimaryButton
            className="btn-to-em"
            key="submit"
            size="large"
            href={EM_URL}>
            {t('emModalToEm')}
          </PrimaryButton>
        </Col>
      </Row>
    </div>
  );
};
